export type WebsiteSearchActionBlok = {
  search_action?: string;
};

export const buildWebsiteSearchAction = (urlTemplate: string | undefined) => {
  const trimmed = typeof urlTemplate === "string" ? urlTemplate.trim() : "";
  if (!trimmed) return null;

  return {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: trimmed,
    },
    "query-input": "required name=search_term_string",
  };
};
